var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistIconGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6425 12.968L12.7209 21.5102C13.0336 21.8044 13.1899 21.9515 13.3743 21.9877C13.4573 22.0041 13.5427 22.0041 13.6258 21.9877C13.8101 21.9515 13.9664 21.8044 14.2792 21.5102L23.3575 12.968C25.9118 10.5646 26.2219 6.60953 24.0737 3.8361L23.6698 3.3146C21.0999 -0.00320958 15.9412 0.553208 14.1355 4.34301C13.8804 4.87835 13.1197 4.87835 12.8645 4.34301C11.0588 0.553208 5.9002 -0.00320958 3.33026 3.31462L2.92633 3.8361C0.77806 6.60953 1.08824 10.5646 3.6425 12.968Z",
    stroke: "#676D75",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistIconGrey);
export default __webpack_public_path__ + "static/media/WishlistIconGrey.7bbea2d4910b878aa068498acab17ed6.svg";
export { ForwardRef as ReactComponent };